export enum ColumnsCanceledOrdersEnum {
	tickerCompany = 'tickerCompany',
	operation = 'operation',
	quantity = 'quantity',
	price = 'price',
	orderType = 'orderType',
	executed = 'executed',
	orderStatus = 'orderStatus',
}
